// Popular slider
new Splide( '#news',{
    padding: '',
    trimSpace: false,
    perPage: 3,
    perMove: 1,
    pagination : false,
    gap: '3rem',
    arrowPath: 'M0 7.00008V9.00008H12L6.5 14.5001L7.92 15.9201L15.84 8.00008L7.92 0.0800781L6.5 1.50008L12 7.00008H0Z',

    breakpoints: {
        1280: {
            perPage: 3,
            padding: { left: '2rem', right: '0rem' },
            arrows: false,
        },
        860: {
            perPage: 2,
        },
        580: {
            perPage: 1,
            padding: { left: '0rem', right: '0rem' },
            gap: '1rem',
        },
    },

    classes: {
    },
} ).mount();



